import { Component, OnInit } from '@angular/core';
import { LoaderindicatorService } from '../../services/loaderindicator/loaderindicator.service';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'mgfw-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.css']
})
export class LoaderComponent implements OnInit {

  isVisible = false;
  messageText = 'Loading';
  constructor(
    private service: LoaderindicatorService
  ) {
    service.subscribe().subscribe((message) => {
      this.messageText = message.text;
      this.isVisible = (message.text !== '');
    });
  }

  ngOnInit() {

  }
}
